<template>
  <b-overlay :show="loading" rounded="lg">
    <div>
      <!-- Modal for delivery completed -->
      <b-modal v-model="modalArrived" title="Delivery Order Completed">
        <b-container>
          <b-row>
            <b-col cols="12">
              <b><u>ALL&nbsp;</u></b> items in this DO accepted by the customer?
            </b-col>
          </b-row>
        </b-container>

        <template #modal-footer>
          <div class="w-100 d-flex">
            <b-row>
              <b-col cols="12">
                <b>Customer Information</b>
              </b-col>
              <b-col cols="12">
                <span>Customer Name <span style="color:red">(*)</span></span>
                <b-input v-model="receiverName" placeholder="Name" class="mb-2" required></b-input>
              </b-col>
              <b-col cols="12">
                <span>Customer Contact Number</span>
                <b-input v-model="receiverNumber" placeholder="Contact Number" class="mb-2"></b-input>
              </b-col>
            </b-row>
          </div>
          <div class="w-100 d-flex justify-content-center align-items-center">
            <b-button variant="success" class="ml-1" @click="updateComplete">Accepted</b-button>
            <b-button variant="danger" class="ml-1" @click="modalArrived = false">No</b-button>
          </div>
        </template>
      </b-modal>

      <!-- Modal for delivery returned -->
      <b-modal v-model="modalReturn" title="Delivery Order Return">
        <b-container>
          <b-row>
            <b-col cols="12">
              Return item(s) to warehouse?
            </b-col>
          </b-row>
        </b-container>

        <template #modal-footer>
          <div class="w-100 d-flex justify-content-center align-items-center">
            <b-button variant="success" class="ml-1" @click="updateReturn">Yes</b-button>
            <b-button variant="danger" class="ml-1" @click="modalReturn = false">No</b-button>
          </div>
        </template>
      </b-modal>

      <!-- Modal for Redelivery -->
      <b-modal v-model="modalRedelivery" title="Re-delivery DO">
        <b-container>
          <b-row>
            <b-col cols="12">
              Are you sure want to Re-delivery this DO?
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-datepicker
                @input="fireFiltering"
                placeholder="Add Re-Delivery Date"
                :min="minDate"
                :date-disabled-fn="dateDisabled"
                v-model="reDelivDate"
                style="margin-top: 10px;"
              />
            </b-col>
          </b-row>
        </b-container>

        <template #modal-footer>
          <div class="w-100 d-flex justify-content-center align-items-center">
            <b-button variant="success" class="ml-1" @click="updateRedelivery">Confirm</b-button>
            <b-button variant="danger" class="ml-1" @click="modalRedelivery = false">Cancel</b-button>
          </div>
        </template>
      </b-modal>

      <b-card no-body>
        <b-card-header>
          <h4>Delivery Order Actions</h4>

        </b-card-header>
        
        <b-card-body>
          <b-col cols="12" class="mt-2">
            <b-col class="px-xl-2 mx-auto d-flex justify-content-center">
              <img :src="daikinLogo" style="width: 50%; height: auto; margin: 0 0 15px 0"/>
            </b-col>
            
            <b-row v-if="processSuccess">
              <b-col cols="12" class="d-flex flex-column align-items-center justify-content-center">
                <label>SAP DO Number</label>
                <p class="font-weight-bold">{{ doData.sapDo }}</p>
              </b-col>
              <b-col cols="12" class="d-flex flex-column align-items-center justify-content-center">
                DO Process successful, this tab/window can be closed
              </b-col>
            </b-row>
            
            <b-row v-else-if="canProcess">
              <b-col cols="12" class="d-flex flex-column align-items-center justify-content-center">
                <label>SAP DO Number</label>
                <p class="font-weight-bold">{{ doData.sapDo }}</p>
              </b-col>
              
              <b-col cols="12" style="margin-bottom: 10px;" class="adjust-on-mobile">
                <b-button
                  @click="modalReturn = true"
                  class="w-100 d-flex justify-content-center"
                  variant="danger"
                >Delivery Returned</b-button>
              </b-col>
              
              <b-col cols="12" style="margin-bottom: 10px;" class="adjust-on-mobile">
                <b-button
                  @click="modalArrived = true"
                  class="w-100 d-flex justify-content-center"
                  variant="success"
                >Accept Delivery</b-button>
              </b-col>
              
              <b-col cols="12" class="adjust-on-mobile">
                <b-button
                  @click="modalRedelivery = true"
                  class="w-100 d-flex justify-content-center"
                  variant="warning"
                >Re-delivery</b-button>
              </b-col>
            </b-row>
            
            <b-row v-else>
              <b-col cols="12" class="d-flex flex-column align-items-center justify-content-center">
                <label>SAP DO Number</label>
                <p class="font-weight-bold">{{ doData.sapDo }}</p>
              </b-col>
              <b-col cols="12" class="d-flex flex-column align-items-center justify-content-center">
                {{ errorMessage }}
              </b-col>
            </b-row>
          </b-col>
        </b-card-body>
      </b-card>
    </div>
  </b-overlay>
</template>
  
  <script>
import { mapActions } from "vuex";

export default {
  props: ["id", "from", "pin",'sapDo','status'],
  data() {
    return {
      daikinLogo: require('@/assets/images/drcc/daikin-logo.png'),
      reDelivDate: '',
      minDate: new Date().toISOString().split('T')[0], // Set minimum date to today
      doData: {},
      loading: false,
      
      // Modal states
      modalArrived: false,
      modalReturn: false,
      modalRedelivery: false,

      // Process states
      canProcess: false, // true if user got in from qr login
      processSuccess: false, // true if change status process is successful
      errorMessage: "", // message shown when canProcess is false
      receiverName: "",
      receiverNumber: "",
    };
  },
      mounted() {
    // Use props from LoginQRV2.vue instead of API call
    this.doData = {
      _id: this.$route.params.id,
      sapDo: this.$route.params.sapDo,
      status: this.$route.params.status,
      pin: this.$route.params.pin
    }
    
    if (this.pin) {
      if (this.status === "Delivery in Progress") {
        this.canProcess = true;
      } else {
        this.errorMessage = "DO is already processed, Please close this tab/window";
      }

      // Handle canceled delivery status
      if (this.status === "Cancel Delivery") {
        this.doData.status = "Delivery Canceled";
      }
    } else {
      this.errorMessage = "Data Invalid, Please Re-scan QR Code";
    }
  },
      methods: {
    ...mapActions({
      updateDO: "delivery/updateDO",
    }),

          // Accept Delivery
    updateComplete() {
      const pin = this.pin;
      if (!this.receiverName) {
        this.$bvToast.toast("Please insert Customer Name", {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        return;
      }
      
      const customerCollect = {
        idNumber: this.receiverNumber,
        name: this.receiverName,
        contact: this.receiverNumber
      };

      this.loading = true;
      this.updateDO({ 
        idDelivery: this.doData._id, 
        deliveryData: { status: "Fulfilled", pin: pin, customerCollect: customerCollect } 
      })
        .then(() => {
          this.$bvToast.toast("The items has been delivered successfully", {
            title: "Success",
            variant: "success",
            solid: true,
          });
          this.processSuccess = true;
        })
        .catch((e) => {
          this.doData.status = "Delivery in Progress";
          
          if (e.response?.data) {
            this.$bvToast.toast(e.response.data.message, {
              title: "Failed",
              variant: "danger",
              solid: true,
            });
          } else {
            this.$bvToast.toast("Connection error. Please refresh the page and try again", {
              title: "Failed",
              variant: "danger",
              solid: true,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
      this.modalArrived = false;
    },

          // Return Delivery
    updateReturn() {
      const data = { ...this.doData };
      const previousStatus = data.status;
      const pin = this.pin;
      const goBackPath = (previousStatus === "Delivery in Progress") ? "Delivery in Progress" : "Scanning Completed";
      data.status = "Returned";
      data.pin = pin;
      
      this.loading = true;
      this.updateDO({ idDelivery: data._id, deliveryData: data })
        .then(() => {
          this.processSuccess = true;
          this.doData.status = "Returned";

          this.$bvToast.toast(
            "Delivery item(s) has been returned by the customer. Please bring back the item(s) to the warehouse and process the Return DO",
            {
              title: "Success",
              variant: "success",
              solid: true,
            }
          );
        })
        .catch((e) => {
          console.error({ e });
          this.doData.status = goBackPath;
          if (e.response?.data) {
            this.$bvToast.toast(e.response.data.message, {
              title: "Failed",
              variant: "danger",
              solid: true,
            });
          } else {
            this.$bvToast.toast("Connection error. Please refresh the page and try again", {
              title: "Failed",
              variant: "danger",
              solid: true,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });

      this.modalReturn = false;
    },

          // Re-delivery
    updateRedelivery() {
      const sapDo = this.doData.sapDo;
      this.loading = true;
      this.updateDO({
        idDelivery: this.doData._id,
        deliveryData: { 
          status: "Re-Delivery", 
          sapDo: sapDo, 
          pin: this.pin, 
          redeliveryDate: this.reDelivDate 
        },
      })
        .then(() => {
          this.$bvToast.toast("Change DO to Re-Delivery Successful", {
            title: "Success",
            variant: "success",
            solid: true,
          });
          this.processSuccess = true;
        })
        .catch((e) => {
          this.doData.status = "Delivery in Progress";
          if (e.response?.data) {
            this.$bvToast.toast(e.response.data.message, {
              title: "Failed",
              variant: "danger",
              solid: true,
            });
          } else {
            this.$bvToast.toast("Connection error. Please refresh the page and try again", {
              title: "Failed",
              variant: "danger",
              solid: true,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
      
      this.modalRedelivery = false;
    },
    
    // Date picker handler
    fireFiltering(value) {
      this.reDelivDate = value;
    },
    
    // Disable Sundays in date picker
    dateDisabled(ymd, date) {
      const weekday = date.getDay();
      return weekday === 0; // Disable Sundays
    },
  },
      // No computed properties needed for core functionality
  };
  </script>
  
  <style>
  /* For mobile phones: */
  @media (max-width: 761px) {
    .adjust-on-mobile {
      margin-bottom: 10px !important;
    }
    .paging-center-mobile {
      justify-content: center !important;
    }
  }
  </style>
  